import { default as config } from "common/config/config";
import type { MintPointsRequest } from "common/models/api/models/MintPointsRequest";
import { UseMutationResult, useMutation, useQueryClient } from "react-query";
import { Queries } from "ui/query/queries";
import type { UseCustomMutationOptions } from "ui/query/react-query-overrides";
import { pointsApi } from "../api/pointsApi";

export default function useAddPoint({
    onSuccess,
    ...options
}: UseCustomMutationOptions<void, unknown, MintPointsRequest> = {}): UseMutationResult<void, unknown, MintPointsRequest> {
    const queryClient = useQueryClient();

    return useMutation(
        async (requestBody: MintPointsRequest) => {
            await pointsApi.mint(requestBody);
        },
        {
            ...options,
            onSuccess: (data, variables, context) => {
                setTimeout(() => {
                    queryClient.invalidateQueries([Queries.POINT_FIND_BY], { refetchInactive: true });
                    queryClient.invalidateQueries(Queries.TRANSACTION_KPIS);
                    queryClient.invalidateQueries(Queries.TRANSACTION_FIND_ALL);
                    queryClient.invalidateQueries(Queries.ORGANIZATION_BALANCE);
                }, config.refetchSendDelay);
                onSuccess?.(data, variables, context);
            },
        },
    );
}
